import { render, staticRenderFns } from "./Coperman.vue?vue&type=template&id=3986cf08&scoped=true&"
import script from "./Coperman.vue?vue&type=script&lang=js&"
export * from "./Coperman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3986cf08",
  null
  
)

export default component.exports